export const TEAM_TYPES = {
  group_chat: 'group_chat',
  atelier: 'atelier',
};
